import {
  Card,
  Table,
  Stack,
  Paper,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Typography,
  TableContainer,
  TablePagination,
  Box,
  IconButton,
  Chip,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import FolderIcon from '@mui/icons-material/Folder';
import Scrollbar from '../scrollbar';
import { UserListHead, UserListToolbar } from '../../sections/@dashboard/user';
import { BUCKETS_TABLE_HEAD, PAGE_SIZE_OPTIONS } from '../../utils/storageConstants';
import { formatDate } from '../../utils/storageUtils';

export default function BucketsTable({
  buckets,
  filteredBuckets,
  bucketsOrder,
  bucketsOrderBy,
  bucketsFilterName,
  bucketsPage,
  bucketsRowsPerPage,
  selectedBuckets,
  bucketsIsNotFound,
  bucketsEmptyRows,
  onRequestSort,
  onFilterByName,
  onChangePage,
  onChangeRowsPerPage,
  onSelectAllClick,
  onSelectClick,
}) {
  return (
    <Card>
      <Box sx={{ p: 2, pb: 0 }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
          <Typography variant="h6">
            <FolderIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
            Buckets
          </Typography>
        </Stack>
        <UserListToolbar
          numSelected={selectedBuckets.length}
          filterName={bucketsFilterName}
          onFilterName={onFilterByName}
          placeholder="Search buckets..."
        />
      </Box>
      <Scrollbar>
        <TableContainer sx={{ minWidth: 600 }}>
          <Table>
            <UserListHead
              order={bucketsOrder}
              orderBy={bucketsOrderBy}
              headLabel={BUCKETS_TABLE_HEAD}
              rowCount={buckets?.length}
              numSelected={selectedBuckets.length}
              onRequestSort={onRequestSort}
              onSelectAllClick={onSelectAllClick}
            />
            <TableBody>
              {filteredBuckets
                .slice(bucketsPage * bucketsRowsPerPage, bucketsPage * bucketsRowsPerPage + bucketsRowsPerPage)
                .map((row) => {
                  const { id, name, path, size, assignedUser, createdDate } = row;
                  const selectedBucket = selectedBuckets.indexOf(name) !== -1;

                  return (
                    <TableRow hover key={id} tabIndex={-1} role="checkbox" selected={selectedBucket}>
                      <TableCell padding="checkbox">
                        <Checkbox checked={selectedBucket} onChange={(event) => onSelectClick(event, name)} />
                      </TableCell>
                      <TableCell align="left">{name}</TableCell>
                      <TableCell align="left">
                        <Typography variant="body2" color="text.secondary" noWrap>
                          {path}
                        </Typography>
                      </TableCell>
                      <TableCell align="left">{size}</TableCell>
                      <TableCell align="left">
                        {assignedUser ? (
                          <Chip label={assignedUser} size="small" color="info" />
                        ) : (
                          <Chip label="No user assigned" color="default" size="small" />
                        )}
                      </TableCell>
                      <TableCell align="left">{formatDate(createdDate)}</TableCell>
                      <TableCell align="left">
                        <IconButton>
                          <MoreVertIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })}
              {bucketsEmptyRows > 0 && (
                <TableRow style={{ height: 53 * bucketsEmptyRows }}>
                  <TableCell colSpan={7} />
                </TableRow>
              )}
            </TableBody>

            {bucketsIsNotFound && (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={7} sx={{ py: 3 }}>
                    <Paper sx={{ textAlign: 'center' }}>
                      <Typography variant="h6" paragraph>
                        Not found
                      </Typography>
                      <Typography variant="body2">
                        No results found for &nbsp;
                        <strong>&quot;{bucketsFilterName}&quot;</strong>.
                        <br /> Try checking for typos or using complete words.
                      </Typography>
                    </Paper>
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>
      </Scrollbar>
      <TablePagination
        rowsPerPageOptions={PAGE_SIZE_OPTIONS}
        component="div"
        count={buckets?.length}
        rowsPerPage={bucketsRowsPerPage}
        page={bucketsPage}
        onPageChange={onChangePage}
        onRowsPerPageChange={onChangeRowsPerPage}
      />
    </Card>
  );
}
